import { createFileRoute } from '@tanstack/react-router';
import { AutomationDropGame } from '@/pages/games/AutomationDrop';

export const Route = createFileRoute('/games/automation-drop')({
  component: AutomationDropGame,
});
